import { AppConfig } from '@shared/utils/app-config';
import { InteractionType, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';
import { MsalGuardConfiguration, MsalInterceptorConfiguration } from '@azure/msal-angular';
import { B2cConfig } from '../config/b2c-config';

export function MSALInstanceFactory(b2cConfig: B2cConfig): IPublicClientApplication {
  return new PublicClientApplication(b2cConfig);
}

export function MSALGuardConfigFactory(b2cConfig: B2cConfig): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: b2cConfig.b2cScopes,
    },
  };
}

export function MSALInterceptorConfigFactory(appConfig: AppConfig, b2cConfig: B2cConfig): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string> | null>([
    [`${appConfig.baseApiUrl}api/users/*/verify`, null], // Allow anonymous access
    [`${appConfig.baseApiUrl}api/users/*/register`, null], // Allow anonymous access
    [`${appConfig.baseApiUrl}api/*`, [b2cConfig.b2cApiScope]], // Protect all other routes
  ]);

  // protect all routes new api
  if (appConfig.baseNewApiUrl && b2cConfig.b2cNewApiScope) {
    protectedResourceMap.set(`${appConfig.baseNewApiUrl}api/*`, [b2cConfig.b2cNewApiScope]);
  }

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap,
  };
}
